import Checkbox from "common/Checkbox/Checkbox";
import NavigationButtons from "common/NavigationButtons/NavigationButtons";
import RowHeader from "common/RowHeader/RowHeader";
import { useContext } from "react";
import { useSelector } from "react-redux";
import JointLifeInformation from "../Common/JointLifeInformation";
import PersonalInformation from "../Common/PersonalInformation";

const SubmitInformation = ({ context }) => {
  const {
    labels,
    navigate,
    sanitize,
    payload,
    updatePayload,
    cancel,
    finalSubmit,
    setError,
  } = useContext(context);

  const investmentDetails = useSelector(
    (state) => state?.commonReducer?.investmentDetailsInStore,
  );

  return (
    <section className="section-three">
      <RowHeader
        header={`${labels?.incomeElection?.incomeBenefitElection} ${
          payload.electionChoice == "J"
            ? labels?.incomeElection?.joint
            : labels?.incomeElection?.single
        }`}
        wrapperClassName="mb-5"
        buttonLabel={labels?.incomeElection?.makeChanges}
        click={() => {
          setError(null);
          cancel();
        }}
      />

      <>
        <RowHeader
          header={labels?.incomeElection?.personalInformation}
          buttonLabel={labels?.incomeElection?.makeChanges}
          click={() => {
            setError(null);
            navigate("/income-election/1");
          }}
        />
        <PersonalInformation labels={labels} data={payload} edit={false} />
      </>

      {payload.electionChoice == "J" && (
        <>
          <RowHeader
            header={labels?.incomeElection?.jointLifeInformation}
            buttonLabel={labels?.incomeElection?.makeChanges}
            click={() => {
              setError(null);
              cancel();
            }}
            wrapperClassName="mt-5"
          />
          <JointLifeInformation
            labels={labels?.incomeElection}
            data={payload}
            showSSN={true}
          />
        </>
      )}

      <p
        className="my-4 pb-4 border-bottom-1"
        dangerouslySetInnerHTML={sanitize(
          investmentDetails?.fundLevelBalance?.some(
            (e) => e.fundType === "T",
          ) && labels?.incomeElection?.submitMsg,
        )}
      />

      <Checkbox
        id="terms"
        label={labels?.incomeElection?.checkboxMsg}
        value={payload.termsCheckbox}
        change={(val) => updatePayload(val, "termsCheckbox")}
        ariaLabel="Terms and Conditions"
      />

      <NavigationButtons
        wrapperClassName="mt-3"
        leftLabel={labels?.incomeElection?.back}
        leftClick={cancel}
        rightLabel={labels?.incomeElection?.submit}
        rightClick={() =>
          finalSubmit("false")
            .then(() => {})
            .catch(() => {})
        }
        rightDisabled={!payload.termsCheckbox}
      />
    </section>
  );
};

export default SubmitInformation;
